"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionField = void 0;
const react_1 = __importStar(require("react"));
const form_panel_1 = require("../../composite/form/fields/form-panel");
const remote_table_field_1 = require("../remote-table-field/remote-table-field");
const collection_columns_1 = require("./collection-columns");
const collection_count_1 = require("./collection-count");
const collection_toolbar_1 = require("./collection-toolbar");
function CollectionField({ disabled, source, title, defaultExpanded = true, useColumns = collection_columns_1.useCollectionColumns, ToolbarComponent = collection_toolbar_1.CollectionToolbar, ...toolbarProps }) {
    const columns = useColumns();
    const tableRef = (0, react_1.useRef)(null);
    const editRef = (0, react_1.useRef)(null);
    const initValuesRef = (0, react_1.useRef)(null);
    const Toolbar = (0, react_1.useMemo)(() => function Toolbar(props) {
        return (react_1.default.createElement(ToolbarComponent, { ...props, ...toolbarProps, ref: editRef, disabled: disabled, initValuesRef: initValuesRef }));
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [disabled, toolbarProps]);
    if (!source) {
        return react_1.default.createElement(react_1.default.Fragment, null, " Missing SOURCE ");
    }
    return (react_1.default.createElement(form_panel_1.FormPanel, { label: title, expandable: true, defaultExpanded: defaultExpanded, summary: react_1.default.createElement(collection_count_1.CollectionCount, { source: source }) },
        react_1.default.createElement(remote_table_field_1.RemoteTableField, { ref: tableRef, disabled: disabled, columns: columns, source: source, maxRows: 15, ToolbarComponent: Toolbar, onRowClick: async (_, index) => {
                var _a, _b;
                if (!disabled) {
                    await ((_a = tableRef.current) === null || _a === void 0 ? void 0 : _a.setSelectedIndex(index));
                    (_b = editRef.current) === null || _b === void 0 ? void 0 : _b.executeAction();
                }
            }, showDetailBtnCond: () => false })));
}
exports.CollectionField = CollectionField;
//# sourceMappingURL=collection-field.js.map